/**
 * DateTime
 */

import StringUtil from './StringUtil';

class DateTime {

  /**
   * @param {Date} date1 - date
   * @param {Date} date2 - date
   * @return {number} milliseconds
   */
  static diffDate( date1, date2 ) {
    if ( !date1 || !date2 ) {
      return 0;
    }

    const diff = date2.getTime() - date1.getTime();
    return diff;
  }

  static isDate( val ) {
    const d = new Date( val );

    return !isNaN( d.valueOf() );
  }

  static toISOString( date ) {
    return date.getUTCFullYear() +
    '-' + StringUtil.fillZero( date.getUTCMonth() + 1 ) +
    '-' + StringUtil.fillZero( date.getUTCDate() ) +
    'T' + StringUtil.fillZero( date.getUTCHours() ) +
    ':' + StringUtil.fillZero( date.getUTCMinutes() ) +
    ':' + StringUtil.fillZero( date.getUTCSeconds() ) +
    '.' + ( date.getUTCMilliseconds() / 1000 ).toFixed( 3 ).slice( 2, 5 ) + 'Z';
  }
}

export default DateTime;
